import firebase from "firebase";
import Constants from "./utils/Constants";

let db = null;
let auth = null;


const init = () => {
    const firebaseConfig = {
        apiKey: "AIzaSyCWPwDfvaJUKo45aKlZZnugRp08fY68Qqs",
        authDomain: "writo-dc3fb.firebaseapp.com",
        databaseURL: "https://writo-dc3fb.firebaseio.com",
        projectId: "writo-dc3fb",
        storageBucket: "writo-dc3fb.appspot.com",
        messagingSenderId: "1089060936232",
        appId: "1:1089060936232:web:d3db04a3ba494e4b83331d",
    };

    firebase.initializeApp(firebaseConfig);

    db = firebase.firestore()
    auth = firebase.auth()
}

/**
 * @param emailID
 * @param password
 * This method is used to login the user.
 */
function login(emailID, password) {
    return auth.signInWithEmailAndPassword(emailID, password).then(res => {
        return res
    })
}

/**
 * This method is used to logout the user.
 */
function logout() {
    return auth.signOut().then(res => {
        return res;
    })
}

export {
    init,
    login,
    logout,
}